import React, { memo } from 'react'
import { classNames } from '@dt/fe-utils'
import './index.scss'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 类型 商城 => mall | 点餐 => '' */
  type?: string;
  /** 宽 */
  width: number;
  /** 高 */
  height?: number;
  /** 图片地址 */
  imgSrc?: string;
  /** 颜色 */
  color?: string;
  /** 数量 */
  cnt?: number;
}

const colors = ['#FF4E50', '#FC913A', '#F9D423', '#EDE574']

const ProductImage: React.FC<IProps> = ({ width, imgSrc, className, cnt, height, color, type = '', ...others }) => {
  const imageHeight = height || width
  const isCover = width === height && width < 120
  const backColor = color ? colors[color[0].charCodeAt(0) % 4] : ''

  // 处理默认图片对应的图标的大小
  let defaultIconWidth = 32
  if (!imgSrc) {
    if (width <= 64) {
      defaultIconWidth = 20
    }
  }

  return (
    <div
      className={classNames('product-image', { cover: isCover, color: !!color }, className)}
      style={{
        width,
        height: imageHeight,
        backgroundImage: imgSrc ? `url(${imgSrc})` : 'none',
        backgroundColor: backColor || null
      }}
      {...others}
    >
      {
        !imgSrc && <i className={`iconfont default-span ${type === 'mall' ? 'icon-moren' : 'icon-meishi'}`} style={{ fontSize: defaultIconWidth }}></i>
      }
      {cnt !== undefined && <span className='product-cnt'>x{cnt}</span>}
    </div>
  )
}

export default memo(ProductImage)
